import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userName: "",
        user: "",
        newMessages: 0,
    },
    mutations: {
        setUsername(state, userName) {
            state.userName = userName;
        },
        setUser(state, user) {
            state.user = user;
        },
        setNewMessage(state, newMessageCount) {
            state.newMessages = newMessageCount;
        }
    },
    actions: {

    },
    getters: {
        getUsername: state => state.userName,
        getUser: state => state.user,
        getNewMessageCount: state => state.newMessages,
    }
})